import { createAction } from 'redux-act';
const assignPageActionMeta = () => ({
  pageMeta: true
});
export const setPageMeta = createAction('SET PAGE META', ({
  pathname = '',
  pageMeta = {}
}) => ({
  pathname,
  pageMeta
}), assignPageActionMeta);